import React from 'react';

const Header = ({ activeTab, setActiveTab, activeSection, setActiveSection }) => {
  const mainTabs = [
    { id: 'home',         label: 'HOME' },
    { id: 'free-service', label: 'FREE SERVICE' },
    { id: 'open-core',    label: 'OPEN CORE' },
    { id: 'community',    label: 'COMMUNITY' },
  ];

  const serviceRows = [
    [
      { id: 'it-news-section',             label: 'IT News' },
      { id: 'pdf-section',                 label: 'PDF 요약' },
      { id: 'movie-section',               label: '영화 추천' },
    ],
    [
      { id: 'place-section',               label: '주변 시설' },
      { id: 'restaurant-section',          label: '맛집 추천' },
      { id: 'coin-analysis-section',       label: '코인 분석' },
    ],
    [
      { id: 'nasdaq-analysis-section',     label: '나스닥 분석' },
      { id: 'language-section',            label: '외국어 학습' },
      { id: 'book-section',                label: '도서 추천' },
    ],
  ];

  const handleMainTabClick = (tabId) => {
    setActiveTab(tabId);
  };

  const handleServiceClick = (sectionId) => {
    setActiveSection(sectionId);
    setActiveTab('free-service');
  };

  return (
    <header>
      <h1>arabangoo.com</h1>
      <div className="nav-buttons">
        {/* 최상위 탭: HOME / FREE SERVICE / COMMUNITY */}
        <div className="nav-row">
          {mainTabs.map(tab => (
            <button
              key={tab.id}
              className={`nav-btn ${activeTab === tab.id ? 'active' : ''}`}
              onClick={() => handleMainTabClick(tab.id)}
            >
              {tab.label}
            </button>
          ))}
        </div>

        {/* FREE SERVICE 선택 시 서비스 서브 탭 */}
        {activeTab === 'free-service' && serviceRows.map((row, rowIndex) => (
          <div key={rowIndex} className="nav-row">
            {row.map(service => (
              <button
                key={service.id}
                className={`nav-btn ${activeSection === service.id ? 'active' : ''}`}
                onClick={() => handleServiceClick(service.id)}
              >
                {service.label}
              </button>
            ))}
          </div>
        ))}
      </div>
    </header>
  );
};

export default Header;
